module.exports = __webpack_public_path__ + "img/stationmanage2.0a943d39.png";